module.exports = __webpack_public_path__ + "static/media/HighIcon.69733b6f.svg";